import { render, staticRenderFns } from "./DiagnosisTreeSelect.vue?vue&type=template&id=16f3ae42&"
import script from "./DiagnosisTreeSelect.vue?vue&type=script&lang=ts&"
export * from "./DiagnosisTreeSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports